var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shadow-custom text-center py-4 border border-neutral-50"},[_c('p',{staticClass:"mb-2 text-sm"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('p',{staticClass:"lg:text-2xl text-xl"},[_vm._v(" "+_vm._s(_vm.value)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }